export const fetchBuildings = async (API_BASE_URL, setBuildingsData) => {
    const url = `${API_BASE_URL}/api/setup/buildings/all`;


    try {
        const response = await fetch(url);
        const data = await response.json();
        setBuildingsData(data);
    } catch (error) {

        console.error('Error fetching buildings: ', error);
    }
};

export const handleSearchChange = (e, buildingsData, setSearchTerm, setDisplayedBuildings, visibleCount) => {
    if (!e || !e.target) {
        return;
    }
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    const filteredBuildings = buildingsData.filter((building) =>
        building.addressLine1 && building.addressLine1.toLowerCase().includes(term)
    );
    setDisplayedBuildings(filteredBuildings.slice(0, visibleCount));
};